// import { blue } from '../customColors'

export default function Pagination (theme: any) {
  return {
    MuiPagination: {
      styleOverrides: {
        root: {
          display: 'flex',
          justifyContent: 'center',
          marginTop: '50px',
          '& .MuiPagination-ul': {
            position: 'relative',
            padding: '5px 0',
            '&:before': {
              background: '#fff',
              borderRadius: '100px',
              bottom: 0,
              content: '""',
              left: '60px',
              position: 'absolute',
              top: 0,
              right: '60px',
              zIndex: '-1'
            }
          },
          '& .MuiPaginationItem-text': {
            color: theme.palette.grey[70],
            fontSize: '14px'
          },
          '& .Mui-selected': {
            color: '#fff',
            borderRadius: '50%',
            height: '45px',
            width: '45px'
          },
          '& .MuiPaginationItem-previousNext': {
            background: '#fff',
            borderRadius: '50%',
            height: '45px',
            margin: '0 9px',
            width: '45px'
          }
        }
      }
    }
  }
}
